import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { WarningPopUp, Image, Anchor } from "hesus-ui-kit";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import addIcon from "@icons/ic-add-green.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import DocumentPreview from "@modules/Document/DocumentPreview/DocumentPreview";

import {
  FileInputLabel,
  FileImageWrapper,
  FileInput,
  DocumentRow,
  FileName,
  DeleteSpan,
} from "./ViewAndUpload.styled";
import "./ViewAndUpload.scss";

const ViewAndUpload = (props) => {
  const { t, id, entity, documents, type } = props;

  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [deletedId, setDeletedId] = useState(0);
  const [documentList, setDocumentList] = useState(documents);
  const [loading, setLoading] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
    setLoading(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .delete(`/documents/${deletedId}`)
        .then(() => {
          // onRefreshData(true);
          setConfirmVisibility(false);
          setActionConfirmStatus(false);
          setDocumentList((current) =>
            current.filter((docs) => docs.id !== deletedId)
          );
          setDeletedId(0);
          setLoading(false);
        })
        .catch(() => {
          // onRefreshData(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const deleteDocument = (id) => {
    setDeletedId(id);
    setConfirmVisibility(true);
  };

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);

  const getDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <FileName key={i}>
          <DeleteSpan>
            {" "}
            <Image
              className="deleteImage"
              src={deleteIcon}
              alt="delete"
              onClick={() => deleteDocument(files[i].id)}
              styles={{ width: "auto" }}
            />
          </DeleteSpan>{" "}
          <Anchor
            clickAction={() => openPreview(files[i])}
            className="view-upload__document-link"
          >
            {files[i].fileName}{" "}
          </Anchor>
        </FileName>
      );
    }
    return docs;
  };

  const onFileSelect = (e) => {
    const dataModified = new FormData();
    if (e.target.files.length > 0) {
      dataModified.append(entity, id);
      dataModified.append(`type`, 19);
      for (let i = 0; i < e.target.files.length; i++) {
        const documentObject = e.target.files[i];
        dataModified.append(`file[${i}][filename]`, documentObject.name);
        dataModified.append(`file[${i}][file]`, documentObject);
      }
      setLoading(true);
      axios
        .post(`/documents`, dataModified, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          setDocumentList(response?.data?.documents);
          setLoading(false);
        })
        .catch((error) => {
          console.log("Error", error);
        });
    }
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <FileInputLabel>{t("DOCUMENTS")}</FileInputLabel>
        <FileImageWrapper htmlFor="document">
          <Image
            src={addIcon}
            alt="upload document"
            styles={{ width: "auto" }}
          />
          {loading && <ClipLoader size={15} color="#1bace4" />}
        </FileImageWrapper>
        <FileInput type="file" id="document" multiple onChange={onFileSelect} />
      </div>

      <DocumentRow>
        {documentList !== null && getDocumentList(documentList)}
      </DocumentRow>

      {isConfirmVisible && (
        <WarningPopUp
          title={t("CENTER_PRODUCT_DOCUMENT_CONFIRMATION_BOX_DELETE")}
          message={t("CENTER_PRODUCT_DOCUMENT_CONFIRMATION_BOX_DELETE_CONTENT")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

ViewAndUpload.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
};

export default withTranslation()(ViewAndUpload);
